import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-educacion',
  templateUrl: './educacion.component.html',
  styleUrls: ['./educacion.component.css']
})
export class EducacionComponent implements OnInit {
  inicio=true;
  especial=false;
  integral=false;
  asesoria = false;
  fotosAsertivas = false;
  constructor() { }

  ngOnInit(): void {
  }
  abreFotosAsertivas(){
    //this.fotosAsertivas= true;
    console.log(this.fotosAsertivas);
    if(this.fotosAsertivas==false){
        this.fotosAsertivas = true;
    }else{
      this.fotosAsertivas = false;
    }
  }
  abreEspecial(){
    this.inicio = false;
    this.especial = true;
    this.integral = false;
  }
  abreIntegral(){
    this.inicio = false;
    this.especial = false;
    this.integral = true;
  }
  abreAsesoria(){
    this.inicio = false;
    this.especial = false;
    this.integral = false;
    this.asesoria = true;
  }

}
